import styled from 'styled-components';
import { useAppDispatch } from '../../../../redux/hooks';
import {
  toggleBounceLabelsAction,
  toggleClusterLabelsAction,
  toggleConversionLabelsAction,
  toggleIsConversionViewAction,
} from '../../../../redux/slices/analyses';
import SegmentSelect from '../../../SegmentSelect';
import SwitchiOS from '../../../SwitchiOS';
import { useChartContext } from '../../ChartContext';
import {
  AssignmentContainer,
  AssignmentLabel,
  AssignmentRowWrapper,
} from '../CentralChartSettingUI';
import KubitTooltip from '../../../KubitTooltip';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { IBreakdownOverallStatus } from '../../../../utils/interfaces';
import { FunnelModeKey } from '../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../utils/types';
import { FUNNEL_CONVERSION_OPTIONS } from './utils';
import { CLUSTER_OPTIONS } from './utils';

const StyledLabel = styled(AssignmentLabel)`
  width: 90px;
`;

const StyledSegmentSelect = styled(SegmentSelect<boolean>)`
  flex: 1;
`;

const FunnelAssignment = () => {
  const dispatch = useAppDispatch();
  const {
    metadata: { analysisId, isBreakdownOverall },
    settings: { chartSettings },
    chartData,
  } = useChartContext();
  assertCondition(chartData.queryType === QueryType.Funnel);
  const {
    isConversionView,
    isShowFunnelConversionLabels,
    isShowFunnelBounceLabels,
    isFunnelClusterMode,
  } = chartSettings;

  const showBounceAndRelative = chartData.mode === FunnelModeKey.Conversion;
  const showCluster =
    isBreakdownOverall !== IBreakdownOverallStatus.NoBreakdown &&
    showBounceAndRelative;

  const onConversionLabelsChange = () => {
    dispatch(
      toggleConversionLabelsAction({
        analysisId,
        value: !isShowFunnelConversionLabels,
      }),
    );
  };

  const onBounceLabelsChange = () => {
    dispatch(
      toggleBounceLabelsAction({
        analysisId,
        value: !isShowFunnelBounceLabels,
      }),
    );
  };

  const onConversionViewChange = () => {
    dispatch(
      toggleIsConversionViewAction({
        analysisId,
        value: !isConversionView,
      }),
    );
  };

  const onClusterChange = () => {
    dispatch(
      toggleClusterLabelsAction({
        analysisId,
        value: !isFunnelClusterMode,
      }),
    );
  };

  return (
    <AssignmentContainer>
      {showCluster && (
        <AssignmentRowWrapper>
          <StyledLabel>Cluster</StyledLabel>
          <StyledSegmentSelect
            options={CLUSTER_OPTIONS}
            value={isFunnelClusterMode}
            onChange={onClusterChange}
          />
        </AssignmentRowWrapper>
      )}
      <AssignmentRowWrapper>
        <StyledLabel>Y-Axis Type</StyledLabel>
        <StyledSegmentSelect
          options={FUNNEL_CONVERSION_OPTIONS}
          value={isConversionView}
          onChange={onConversionViewChange}
        />
      </AssignmentRowWrapper>
      <AssignmentRowWrapper>
        <KubitTooltip content="Display Conversion Rate">
          <StyledLabel>Conversion Rate</StyledLabel>
        </KubitTooltip>
        <SwitchiOS
          isChecked={isShowFunnelConversionLabels}
          onClick={onConversionLabelsChange}
        />
      </AssignmentRowWrapper>
      {showBounceAndRelative && (
        <AssignmentRowWrapper>
          <KubitTooltip content="Display Bounce Rate">
            <StyledLabel>Bounce Rate</StyledLabel>
          </KubitTooltip>
          <SwitchiOS
            isChecked={isShowFunnelBounceLabels}
            onClick={onBounceLabelsChange}
          />
        </AssignmentRowWrapper>
      )}
    </AssignmentContainer>
  );
};

export default FunnelAssignment;
